import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/api/client';

/**
 * Authorized image (photo / logo) from an API path relative to /api/v1, shown through an object
 * URL (an <img src> to the API could not carry the access token).
 */
export function useApiImage(path: string | null | undefined): string | null {
  const [url, setUrl] = useState<{ path: string; url: string } | null>(null);
  useEffect(() => {
    if (!path) return;
    const controller = new AbortController();
    let objectUrl: string | null = null;
    apiClient
      .getBlob(path, { signal: controller.signal })
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        setUrl({ path, url: objectUrl });
      })
      .catch(() => undefined);
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);
  return path && url?.path === path ? url.url : null;
}
